var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-container", attrs: { id: "PTV-content" } },
      [
        _vm.showLoadingScreen
          ? _c("MMP_LoadingScreen", {
              staticClass: "loading",
              attrs: { user: _vm.user },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("DT_NavBar", {
          ref: "DT_NavBar",
          attrs: {
            showMenu: true,
            tool: "TRT",
            menuCollapsed: _vm.menuCollapsed,
            mapsMode: _vm.mapsMode,
            versionReleaseInfo: _vm.versionReleaseInfo,
          },
          on: {
            initMaps: function ($event) {
              return _vm.initMaps()
            },
            destroyMap: function ($event) {
              return _vm.destroyMap()
            },
            mapSelection: function ($event) {
              _vm.mapsMode = true
            },
            loadProject: function ($event) {
              return _vm.loadProject($event)
            },
            reset: function ($event) {
              return _vm.reset($event)
            },
            toggleCollapse: _vm.toggleCollapse,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-content" },
          [
            !_vm.mapsMode
              ? _c("TRT_Dashboard", {
                  staticClass: "dashboard",
                  attrs: { user: _vm.user, lidarFlag: _vm.lidarFlag },
                  on: {
                    loadProject: function ($event) {
                      return _vm.loadProject($event)
                    },
                    notification: function ($event) {
                      return _vm.pushNotification($event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mapsMode
              ? _c(
                  "div",
                  { staticClass: "maps-content" },
                  [
                    _c("div", {
                      staticStyle: { height: "100%", width: "100%" },
                      attrs: { id: "ptv-map" },
                    }),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("DT_ZoomLevel", {
                          staticClass: "ptv-zoom-position",
                          attrs: { map: _vm.map },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("DT_Tools", {
                          staticClass: "lat-long-position",
                          attrs: {
                            map: _vm.map,
                            mapsMode: _vm.mapsMode,
                            clickedCoords: _vm.clickedCoords,
                            showSnippingTool: _vm.showSnippingTool,
                            showMeasuringTool: _vm.showMeasuringTool,
                            lidarMinZoomAchieved: _vm.lidarMinZoomAchieved,
                            showLidarPanel: _vm.showLidarPanel,
                            measurement: _vm.measurement,
                            polygonsSelected: _vm.polygonsSelected,
                            user: _vm.user,
                            selectedExtent: _vm.selectedExtent,
                            distinct_lidar: _vm.distinct_lidar,
                            distinct_trails: _vm.distinct_trails,
                            trailsLoading: _vm.trailsLoading,
                            showTrailsPanel: _vm.showTrailsPanel,
                            lidarIsLoading: _vm.lidarIsLoading,
                            polygonVectorLayers: _vm.polygonVectorLayers,
                            selectedRelease: _vm.selectedRelease,
                            zoomLevel: _vm.zoomLevel,
                            selectedTrails: _vm.selectedTrails,
                            cart: _vm.cart,
                            lidarTrailsActive: _vm.lidarTrailsActive,
                            lidarFlag: _vm.lidarFlag,
                          },
                          on: {
                            addPoint: function ($event) {
                              return _vm.addPoint($event)
                            },
                            clearPolygon: function ($event) {
                              return _vm.clearPolygon()
                            },
                            onPointcloudClick: function ($event) {
                              return _vm.onPointcloudClick($event)
                            },
                            yearFilterChanged: function ($event) {
                              return _vm.onYearFilterChanged($event)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("DT_Widgets", {
                          ref: "ptvWidgets",
                          staticClass: "widget-position",
                          attrs: {
                            currentBaseMap: _vm.currentBaseMap,
                            map: _vm.map,
                            selectedExtent: _vm.selectedExtent,
                            user: this.user,
                            polygonsSelected: _vm.polygonsSelected,
                            ptvMapFlag: _vm.ptvMapFlag,
                            lidarFlag: _vm.lidarFlag,
                          },
                          on: {
                            addPolygon: _vm.addPolygonToMap,
                            removePolygons: function ($event) {
                              return _vm.removePolygons()
                            },
                            toggleBaseLayer: function ($event) {
                              return _vm.toggleBaseLayer($event)
                            },
                            toggleMeasuringTool: function ($event) {
                              return _vm.toggleMeasuringTool()
                            },
                            toggleSnippingTool: function ($event) {
                              return _vm.toggleSnippingTool()
                            },
                            measurement: function ($event) {
                              _vm.measurement = $event
                            },
                            removePolygonSelect: function ($event) {
                              return _vm.removePolygonListener()
                            },
                            addPolygonSelect: _vm.addPolygonListener,
                            datasetSelected: function ($event) {
                              return _vm.datasetSelected($event)
                            },
                            clearPolygon: function ($event) {
                              return _vm.clearPolygon()
                            },
                            acknowledgeTutorial: function ($event) {
                              return _vm.acknowledgeTutorial($event)
                            },
                            lidarSelection: function ($event) {
                              return _vm.lidarSelection($event)
                            },
                            lidarSelectionByPcIds: function ($event) {
                              return _vm.lidarSelectionByPcIds($event)
                            },
                            clearCart: _vm.clearCart,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("DT_LayerList", {
                          staticClass: "layer-list-position",
                          attrs: {
                            drtLayersButtonsCtrl: _vm.drtLayersButtonsCtrl,
                            map: _vm.map,
                            ptv_layersObj: _vm.ptv_layersObj,
                            selectedRelease: _vm.selectedRelease,
                            layerResponse: _vm.layerResponse,
                            zoomEnded: _vm.zoomEnded,
                            zoomLevelCap: _vm.zoomLevelCap,
                            layerLegend: _vm.layerLegend,
                            layerLegendMaxHeight: _vm.layerLegendMaxHeight,
                            layerLegendName: _vm.layerLegendName,
                            legendImgSrc: _vm.legendImgSrc,
                            legendMinimized: _vm.layerLegendMinimized,
                            mapsMode: _vm.mapsMode,
                            selectedExtent: _vm.selectedExtent,
                            distinct_lidar: _vm.distinct_lidar,
                            showTrailsPanel: _vm.showTrailsPanel,
                            selectedTrails: _vm.selectedTrails,
                            distinct_trails: _vm.distinct_trails,
                            trailsLoading: _vm.trailsLoading,
                            lidarIsLoading: _vm.lidarIsLoading,
                            polygonVectorLayers: _vm.polygonVectorLayers,
                            zoomLevel: _vm.zoomLevel,
                            cart: _vm.cart,
                            disableTrailGroups: _vm.disableTrailGroups,
                          },
                          on: {
                            onPointcloudClick: function ($event) {
                              return _vm.onPointcloudClick($event)
                            },
                            closeLegend: function ($event) {
                              return _vm.closeLegend()
                            },
                            maximizeLegend: function ($event) {
                              return _vm.maxOrMinLegend(false)
                            },
                            minimizeLegend: function ($event) {
                              return _vm.maxOrMinLegend(true)
                            },
                            updateZoomEnded: function ($event) {
                              _vm.zoomEnded = $event
                            },
                            toggleLayerVisibility: function ($event) {
                              return _vm.toggleLayerVisibility($event)
                            },
                            loadAttributes: function ($event) {
                              return _vm.loadAttributes($event)
                            },
                            getShowAttributes: function ($event) {
                              return _vm.getShowAttributes($event)
                            },
                            layerButtonsChanged: function ($event) {
                              _vm.drtLayersButtonsCtrl = $event
                            },
                            toTopOfList: function ($event) {
                              return _vm.putLayerOnTop($event)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("DT_ZoomWidget", {
                          staticClass: "zoom-btns-position",
                          attrs: { map: _vm.map },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mapsMode
                      ? _c("DT_Tutorial", {
                          staticClass: "tutorial-position",
                          on: {
                            triggerTutorial: function ($event) {
                              return _vm.triggerTRTTutorial()
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "Moveable",
                      _vm._b(
                        {
                          staticClass: "moveable attribute-table",
                          on: {
                            drag: function ($event) {
                              return _vm.handleDrag($event)
                            },
                          },
                        },
                        "Moveable",
                        _vm.moveable,
                        false
                      ),
                      [
                        _vm.showAttributes && _vm.mapsMode
                          ? _c(
                              "div",
                              {
                                staticClass: "moveable-container-attributes",
                                attrs: { id: "attributes" },
                              },
                              [
                                _c("DT_Attributes", {
                                  attrs: {
                                    attributesName: _vm.attributesName,
                                    attributesMinimized:
                                      _vm.attributesPanelMinimized,
                                    attribResponse: _vm.attribResponse,
                                    features: _vm.features,
                                    feature_index: _vm.feature_index,
                                  },
                                  on: {
                                    closeAttTable: function ($event) {
                                      return _vm.closeAttTable()
                                    },
                                    maximizeAttributes: function ($event) {
                                      return _vm.maxOrMinAttributes(false)
                                    },
                                    minimizeAttributes: function ($event) {
                                      return _vm.maxOrMinAttributes(true)
                                    },
                                    showNextAttribute: function ($event) {
                                      return _vm.showNextAttribute($event)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.mapsMode && _vm.showTrailsPanel
                      ? _c("TRT_TrailsCart", {
                          staticClass: "cart-position",
                          attrs: {
                            cart: _vm.cart,
                            selectedTrails: _vm.selectedTrails,
                            map: _vm.map,
                            selectedExtent: _vm.selectedExtent,
                            user: _vm.user,
                            showTrailsPanel: _vm.showTrailsPanel,
                            lidarFlag: _vm.lidarFlag,
                            polygonsSelected: _vm.polygonsSelected,
                            kmzLoadingTotal: _vm.kmzLoadingTotal,
                            kmzLoadingDone: _vm.kmzLoadingDone,
                          },
                          on: {
                            removeItem: function ($event) {
                              return _vm.onPointcloudClick($event)
                            },
                            removePolygons: function ($event) {
                              return _vm.removePolygons()
                            },
                            clearCart: _vm.clearCart,
                            clearPolygon: _vm.clearPolygon,
                            notification: function ($event) {
                              return _vm.pushNotification($event)
                            },
                            "admin-notification": function ($event) {
                              return _vm.sendAdminNotifications($event)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("DT_ReleaseHistory", { attrs: { user: this.user } }),
            _vm._v(" "),
            _c("MMP_MapSettings", {
              attrs: { userOrg: this.user ? this.user.org : null },
            }),
            _vm._v(" "),
            _c("DT_ChangePassword"),
            _vm._v(" "),
            _c("DT_ReleaseModal", {
              attrs: { project_id: _vm.project_id },
              on: {
                datasetSelected: function ($event) {
                  return _vm.datasetSelected($event)
                },
              },
            }),
            _vm._v(" "),
            _c("DT_ReleaseNotes", {
              ref: "ReleaseNotesRef",
              attrs: { user: _vm.user },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("head", [
      _c("meta", {
        attrs: { "http-equiv": "Cache-Control", content: "no-cache" },
      }),
      _vm._v(" "),
      _c("meta", { attrs: { "http-equiv": "Pragma", content: "no-cache" } }),
      _vm._v(" "),
      _c("meta", { attrs: { "http-equiv": "Expires", content: "0" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }